<template>
    <b-card no-body>
        <v-table    ref="table"
                    search
                    pagination = "server"
                    :excel-callback="exportExcel"
                    name="isbankasi-hgs-charge"
                    :items-provider="provider"
                    :fields="fields">
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-md-4 mb-1 mb-md-0">
                                <flat-pickr v-model="dateRange" class="form-control" :config="{altInput:true, altFormat:'d.m.Y', dateFormat: 'Y-m-d',mode:'range', locale:'tr'}" placeholder="Tarih Aralığı Seçiniz"/>
                            </div>
                            <div class="col-md-auto col-12">
                                <button class="btn btn-success w-100" v-on:click="getByDate">
                                    Sorgula
                                </button>
                            </div>
                        </div>
                    </template>
                    <template #custom-html>
                        <div class="row px-1 py-0">
                            <div class="col-12 mb-1">
                                <h5 class="mb-0 text-secondary">TOPLAM YÜKLEME BİLGİLERİ</h5>
                                <hr class="mb-0 mt-50"/>
                            </div>
                            <div class="col-md-4 mb-1">
                                <v-stats-box text="Toplam Tutar" variant="danger" icon="currency_lira" :value="stats.TotalAmountWithoutTax" short-text="Vergi Hariç"></v-stats-box>
                            </div>
                            <div class="col-md-4 mb-1">
                                <v-stats-box text="Toplam Tutar" variant="success" icon="currency_lira" :value="stats.TotalAmount" short-text="Vergi Dahil"></v-stats-box>
                            </div>
                            <div class="col-md-4 mb-1">
                                <v-stats-box text="Yükleme Adedi" variant="warning" icon="credit_card" :value="stats.TotalCount"></v-stats-box>
                            </div>
                            <div class="col-12 mb-1">
                                <h5 class="mb-0 text-secondary">TOPLAM YÜKLEME İPTAL BİLGİLERİ</h5>
                                <hr class="mb-0 mt-50"/>
                            </div>
                            <div class="col-md-4 mb-1">
                                <v-stats-box text="Toplam Tutar" variant="danger" icon="currency_lira" :value="canceledStats.TotalAmountWithoutTax" short-text="Vergi Hariç"></v-stats-box>
                            </div>
                            <div class="col-md-4 mb-1">
                                <v-stats-box text="Toplam Tutar" variant="success" icon="currency_lira" :value="canceledStats.TotalAmount" short-text="Vergi Dahil"></v-stats-box>
                            </div>
                            <div class="col-md-4 mb-1">
                                <v-stats-box text="İptal Adedi" variant="warning" icon="credit_card" :value="canceledStats.TotalCount" ></v-stats-box>
                            </div>
                        </div>
                    </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ReportsApi from '@/api/reports' 
import Additional from '@/utilities/additional'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
import moment from 'moment'
import VStatsBox from '@/components/VStatsBox.vue'

export default {
    components:{
        BCard,
        flatPickr,
        VStatsBox
    },
    created(){
        this.dateRange = this.c_month
    },
    data(){
        return{
            dateRange:null,
            queryParam:null,
            fields:[
                { name:"Plaka",key:"Plate",thClass:"w-20" ,sortable:true},
                { name:"HGS Numarası",key:"ProductNumber",thClass:"w-20",sortable:true },
                { name:"İşlem Tipi",key:"TransactionType",thClass:"w-20",sortable:true },
                { name:"İşlem Zamanı",key:"TransactionDate",thClass:"w-20",sortable:true },
                { name:"İşlem Ücreti",key:"TransactionAmount",thClass:"w-10",tdClass:"text-right",sortable:true, },
                { name:"İşlem Ücreti (VH)",key:"TransactionAmountWithoutTax",thClass:"w-10",tdClass:"text-right",sortable:true,sortKey:'TransactionAmount' },
            ],
            stats:{
                TotalCount:null,
                TotalAmount:null,
                TotalAmountWithoutTax:null
            },
            canceledStats:{
                TotalCount:null,
                TotalAmount:null,
                TotalAmountWithoutTax:null
            }
        }
    },
    methods:{
        getByDate(){
            this.$refs.table.refresh()
        },
        provider(data){
            this.queryParam = data.QueryParam
            this.getStats(data.QueryParam)
            return ReportsApi.IsBankasiHGS.ChargeTable(data,this.c_dates.StartDate,this.c_dates.EndDate)
        },
        exportExcel(){
            this.$refs.table.setExcelLoading(true)
            ReportsApi.IsBankasiHGS.ExcelExportCharge(this.c_dates.StartDate,this.c_dates.EndDate,this.queryParam).then(res=>{
                Additional.DownloadFile(res.data,"HGS Yükleme Verileri.xlsx")
                this.$refs.table.setExcelLoading(false)
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.setExcelLoading(false)
            })
        },
        getStats(searchValue){
            ReportsApi.IsBankasiHGS.StatsCharge({StartDate:this.c_dates.StartDate,EndDate:this.c_dates.EndDate,SearchParam:searchValue}).then(res=>{
                this.stats.TotalCount = res.data.Data.TotalCount
                this.stats.TotalAmount = res.data.Data.TotalAmount
                this.stats.TotalAmountWithoutTax = res.data.Data.TotalAmountWithoutTax
            })
            ReportsApi.IsBankasiHGS.StatsChargeCanceled({StartDate:this.c_dates.StartDate,EndDate:this.c_dates.EndDate,SearchParam:searchValue}).then(res=>{
                this.canceledStats.TotalCount = res.data.Data.TotalCount
                this.canceledStats.TotalAmount = res.data.Data.TotalAmount
                this.canceledStats.TotalAmountWithoutTax = res.data.Data.TotalAmountWithoutTax
            })
        }
    },
    computed:{
        c_dates(){
            return {
                StartDate : this.dateRange?.split(' - ')[0] || null,
                EndDate : this.dateRange?.split(' - ')[1] || null
            }
        },
        c_month(){
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [moment(firstDay).format("YYYY-MM-DD"),moment(lastDay).format("YYYY-MM-DD")].join(" - ")
        }
    }
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>